<template>
  <v-main class="d-flex v-application v-application v-application--is-ltr theme--light" style="height: calc(100vh - 56px)">
    <div data-app style="height: calc(100vh - 56px)">
      <v-row class="m-0">
        <v-col class="p-0" cols="2" style="margin-right: 12px" v-if="false">
          <v-select
              :items="dateModes"
              v-model="currentMode"
              filled
              hide-details
              label="Anzeige"
              class="mt-0"
          ></v-select>
        </v-col>
        <v-col class="p-0" cols="2" style="margin-right: 12px" v-if="currentMode === 'Q'">
          <v-select
              style="padding-top: 24px"
              :items="quartals"
              v-model="currentQuartal"
              hide-details
              label="Quartal"
              class="mt-0"
          ></v-select>
        </v-col>
        <v-col class="p-0" cols="2" style="margin-right: 12px" v-if="currentMode === 'H'">
          <v-select
              style="padding-top: 24px"
              :items="halfs"
              v-model="currentHalf"
              hide-details
              label="Halbjahr"
              class="mt-0"
          ></v-select>
        </v-col>
        <v-col class="p-0" cols="2">
          <v-row style="padding-top: 8px">
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(-1)"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <v-col style="padding: 12px 0">
              <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedDate"
                      label="Zeitraum"
                      prepend-icon="mdi-calendar"
                      readonly
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    :type="currentMode === 'M' ? 'month' : 'date'"
                    scrollable
                    locale="de"
                    :key="currentMode"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="setDate(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(1)"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col></v-col>
        <v-btn
            block
            tile
            color="success"
            style="margin-top: 12px; margin-right: 8px; height: 32px; min-width: 200px !important; max-width: 200px !important;
                          border-radius: 14px;
                          color: white !important;"
            :disabled="currentPdf === 'Bitte Auswahl treffen.pdf'"
            @click="download"
        >
          <v-icon left>
            mdi-content-save
          </v-icon>
          Herunterladen
        </v-btn>
        <v-btn
            block
            tile
            color="success"
            style="margin-top: 12px; margin-right: 4px; height: 32px; min-width: 200px !important; max-width: 200px !important;
                          border-radius: 14px;
                          color: white !important;"
            :disabled="currentPdf === 'Bitte Auswahl treffen.pdf'"
            @click="print"
        >
          <v-icon left>
            mdi-printer
          </v-icon>
          Drucken
        </v-btn>
      </v-row>
      <v-row class="m-0" style="height: calc(100vh - 56px - 56px)">
        <v-col sm="3" md="2" xl="2" class="pt-1" style="height: calc(100vh - 56px - 56px)">
          <v-list style="max-height: 100%; overflow-y: auto" class="disable-text-selection">
            <v-list-item-group
                v-model="currentMita"
                color="primary"
                multiple
            >
              <v-list-item
                  v-for="(mita, i) in filteredItems"
                  :key="mita.id"
                  @click.native="handleItemClick($event, i)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="mita.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col sm="9" md="10" xl="10" id="viewer" style="height: calc(100vh - 56px - 56px); padding-top: 2px; padding-left: 0px; padding-right: 0px; padding-bottom: 6px" >
          <iframe :src="currentPdf" name="print_frame" id="print_frame" style="width: 100%; height: 100%; border: none; border-radius: 4px;"></iframe>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy"

import _ from 'lodash';


export default {
  name: "Lohn",
  components: {
  },
  data: () => ({
    dateModes: [{text: "Monat", value: "M"}, {text: "Quartal", value: "Q"}, {text: "halbes Jahr", value: "H"}, {text: "Jahr", value: "Y"}],
    currentMode: "M",
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    quartals: [{text: "Q1", value: 1}, {text: "Q2", value: 2}, {text: "Q3", value: 3}, {text: "Q4", value: 4}],
    halfs: [{text: "H1", value: 1}, {text: "H2", value: 2}],
    currentQuartal: 1,
    currentHalf: 1,

    migrs: [],
    mitas: [],
    mitasFlat: [],
    activeMita:[],

    overlay: true,
    currentMita: [],
    userDays: [],

    search: '',
    date: new Date().toISOString().substr(0, 7),
    selectedDate: new Date().toISOString().substr(0, 10),
    modal: false,
    holliday_lohn: null,
    currentPdf: 'Bitte Auswahl treffen.pdf',
    lastClickedIndex: null,

  }),
  computed: {
    formatedDate() {
      let splits = this.date.split("-");
      if (this.currentMode === 'M') {
        return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
      } else {
        return splits[0]
      }
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if(!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
  },
  mounted () {
    //this.$parent.$emit('close-side-bar');
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/responsible_users'
    ).then(this.responseOkGet, this.responseError)
  },
  watch: {
    currentMode() {
      this.throttledQuery();
    },
    currentQuartal() {
      this.throttledQuery();
    },
    currentHalf() {
      this.throttledQuery();
    },
    currentMita() {
      this.throttledQuery();
    },
    selectedDate() {
      this.throttledQuery();
    },
  },
  methods: {
    print() {
      setTimeout(() => {
        window.frames["print_frame"].focus();
        window.frames["print_frame"].print();
      },500);
    },
    download() {
      setTimeout(() => {
        window.frames["print_frame"].focus();
        const a = document.createElement('a');
        a.href = this.currentPdf;
        a.download =  "Auswertung.pdf";
        a.style.position = 'fixed';
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },500);
    },
    throttledQuery: _.debounce(function(query) {
      this.queryData()
    }, 100),
    queryData() {
      if (this.currentMita.length === 0) {
        this.currentPdf = 'Bitte Auswahl treffen.pdf';
        return;
      }
      let users = [];
      for (let i = 0; i < this.currentMita.length; i++) {
        users.push(this.filteredItems[this.currentMita[i]].bis_id);
      }
      let year = parseInt(this.selectedDate.split("-")[0]);
      let intervalValue = 0;
      switch (this.currentMode) {
        case 'M':
          intervalValue = parseInt(this.selectedDate.split("-")[1]);
          break;
        case 'Q':
          intervalValue = this.currentQuartal;
          break;
        case 'H':
          intervalValue = this.currentHalf;
          break;
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/reports/ueb_hol',
          {
            user_gischls: users,
            interval_year: year,
            interval: this.currentMode,
            interval_value: intervalValue,
            type: "lohn",
            key: sessionStorage.getItem("aes"),
          },
          {responseType: 'blob'}
      ).then(this.responseOkTrap, this.responseError);
    },
    handleItemClick(event, index) {
      console.log("Clicked item index:", index, "Shift key pressed:", event.shiftKey, "Last clicked index:", this.lastClickedIndex)
      if (event.shiftKey && this.lastClickedIndex !== null) {
        // Clear any accidental text selection triggered by the OS
        window.getSelection().removeAllRanges();

        // Calculate the boundaries of the range
        const start = Math.min(this.lastClickedIndex, index);
        const end = Math.max(this.lastClickedIndex, index);

        const range = [];
        for (let i = start; i <= end; i++) {
          range.push(i);
        }

        // Merge the newly created range with whatever is already selected.
        // Using a Set automatically filters out duplicate indices.
        const newSelected = new Set([...this.currentMita, ...range]);

        // Wait for Vuetify's native toggle to process, then override it with our full range
        this.$nextTick(() => {
          this.currentMita = Array.from(newSelected);
        });
      }

      // Always store the index of the item just clicked to serve as the new anchor
      this.lastClickedIndex = index;
    },
    moveDate(direction) {
      let curDate = new Date(this.selectedDate);
      let date;
      switch (this.currentMode) {
        case 'M':
          date = new Date(curDate.setMonth(curDate.getMonth() + direction)).toISOString().substring(0, 7);
          break
        default :
          date = new Date(curDate.setFullYear(curDate.getFullYear() + direction)).toISOString().substring(0, 10);
          break
      }
      this.setDate(date);
    },
    changeToMonth(month) {
      let date = this.selectedDate.split("-")[0] + '-' + ('' + month).padStart(2, '0');
      this.currentMode = 'M';
      this.setDate(date);
    },
    sortedItems(migr) {
      return _orderBy(this.mitas[migr], 'name');
    },
    clearSearch () {
      this.search="";
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        for (let i = 0; i < response.body.migrs.length; i++) {
          this.activeMita.push(null);
        }
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        this.holliday_lohn = response.body.holliday_lohn;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      console.log(response)
      const fileURL = URL.createObjectURL(new Blob([response.body], {type: 'application/pdf'}));
      this.currentPdf = fileURL;
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setDate(date) {
      if (this.currentMode === 'M') {
        date = date + "-01";
      }
      this.date = date;
      this.$refs.dialog.save(date);
      this.selectedDate = date;
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
  }
}
</script>

<style scoped lang="scss">


/* Crucial for UX: Prevents ugly text highlighting during shift-click actions */
.disable-text-selection {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.v-list-item-group .v-list-item--active{
  background-color: #e4e5e6 !important;
}

::v-deep .v-list-item--link:before {
  background-color: transparent;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

::v-deep .saldo input {
  font-weight: 500;
}

::v-deep .pos input {
  color: green !important;
}

::v-deep .neg input {
  color: red !important;
}


::v-deep .v-list-item {
  min-height: 36px!important;
  padding: 0 8px!important;
}

::v-deep .v-list-item__content {
  padding: 8px 0!important;
}

</style>
